"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return getCanvasBlob;
    }
});
function getCanvasBlob(blob) {
    const filename = "newPreview.jpg";
    const fileType = "image/jpeg";
    if (blob instanceof Blob) {
        return new File([
            blob
        ], filename, {
            type: fileType
        });
    } else {
        console.error({
            error: "Invalid blob",
            function: getCanvasBlob.name
        });
        return null;
    }
}
